import { Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, map, take, timer } from 'rxjs';
import { LoginService } from 'src/app/services/login.service';
import { Alert } from 'src/app/shared/models/Alert';
import { SimpleRequestString } from 'src/app/shared/models/SimpleRequestString';
import { AlertService } from 'src/app/shared/services/alert.service';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-security-verification',
    templateUrl: './security-verification.component.html',
    styleUrls: ['./security-verification.component.css'],
    imports: [CommonModule, FormsModule]
})
export class SecurityVerificationComponent {
  otpInputs: string[] = new Array(6).fill('');
  currentInput = 0;
  fieldsCompleted = false;
  alert: Alert = {} as Alert;
  simpleRequestString: SimpleRequestString = {} as SimpleRequestString;
  contador$: Observable<number> = new Observable<number>();
  tiempoInicial = 5;
  contador: number = this.tiempoInicial;
  mostrarMensaje: boolean = false;
  requestString: SimpleRequestString = {} as SimpleRequestString;
  resendRequestString: SimpleRequestString = {} as SimpleRequestString;
  phone?: string = '';
  email: string = '';
  contadorResendClicks = 0;
  mostrarMensajeCorreo = false;
  mostrarMensajeCorreoFinal = false;

  selectedMethod?: string | null = null;

  constructor(
    private router: Router,
    private alertService: AlertService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    const email = localStorage.getItem('UserEmail');
    this.selectedMethod = localStorage.getItem('verifyCodeBy');

    //console.log(email);
    if (email != null) {
      this.email = email;
      this.requestString.value = email;
      this.loginService.getUserByEmail(this.requestString).subscribe(
        ({ StatusCode, Message, Data }) =>
          Data !== null
            ? this.handleGetUserByEmail(Data)
            : this.handleError(StatusCode),
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000,
          };
          localStorage.setItem('AlertObject', JSON.stringify(this.alert));
          this.alertService.updateAlertState(this.alert);
          this.clearFields();
        }
      );
      this.iniciarContador();
    }
  }

  handleError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(this.alert);
    this.clearFields();
  }

  handleGetUserByEmail(data: SimpleRequestString) {
      this.phone = data.value;

    //if (data.value != null) this.lastDigitsPhone = data.value.slice(-4);
  }

  iniciarContador() {
    const tiempoInicial = 5;
    this.contador = tiempoInicial;
    this.mostrarMensaje = false;

    timer(0, 1000)
      .pipe(
        take(tiempoInicial + 1),
        map((segundo) => tiempoInicial - segundo)
      )
      .subscribe((segundo) => {
        this.contador = segundo;
        if (this.contadorResendClicks > 2) {
          this.mostrarMensajeCorreo = false;
          this.mostrarMensajeCorreoFinal = true;
        } else if (segundo === 0) {
          this.mostrarMensaje = true;
        }
      });
  }

  onInputChange(value: string, index: number): void {
    const inputValue = value.trim();
    
    // Verifica si el valor ingresado es un número
    if (/^[0-9]$/.test(inputValue)) {
      // Si es un número, actualiza el valor y cambia el enfoque al siguiente campo
      this.otpInputs[index] = inputValue;
      if (index < 5) {
        this.focusNextInput(index);
      }
    } else {
      // Si no es un número, limpia el campo actual
      this.otpInputs[index] = '';
    }

    // Comprueba si todos los campos están completados
    this.checkFieldsCompleted();
  }

  checkFieldsCompleted(): void {
    this.fieldsCompleted = this.otpInputs.every((input) =>
      /^[0-9]$/.test(input)
    );
  }

  focusNextInput(index: number): void {
    const nextIndex = index < 5 ? index + 1 : index;
    const nextField = document.getElementById(
      `otpField${nextIndex}`
    ) as HTMLInputElement;
    if (nextField) {
      nextField.focus();
      this.currentInput = nextIndex;
    }
  }

  focusPreviousInput(index: number): void {
    const prevIndex = index > 0 ? index - 1 : index;
    const prevField = document.getElementById(
      `otpField${prevIndex}`
    ) as HTMLInputElement;
    if (prevField) {
      prevField.focus();
      this.currentInput = prevIndex;
    }
  }

  handleKeydown(event: KeyboardEvent, index: number): void {
    const allowedKeys = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'Backspace',
    ];
    if (!allowedKeys.includes(event.key)) {
      // Prevenir la entrada si la tecla no es un dígito o Backspace
      event.preventDefault();
    } else if (
      event.key === 'Backspace' &&
      index > 0 &&
      this.otpInputs[index].length === 0
    ) {
      // Manejar la navegación hacia atrás con la tecla Backspace
      this.focusPreviousInput(index);
    }

    if (event.key === 'Enter' && this.fieldsCompleted) {
      this.obtenerCodigo();
    }
  }

  

  obtenerCodigo(): void {
    
    const codigoCompleto = this.otpInputs.join('');
    const userEmail = localStorage.getItem('UserEmail');

     const verifyCodeBy = localStorage.getItem('verifyCodeBy');

    if (userEmail != null && codigoCompleto != null) {
      if ( verifyCodeBy === 'email') {
        this.simpleRequestString.value = userEmail;
        this.simpleRequestString.secondValue = codigoCompleto;
        this.loginService.verifyCodeEmail(this.simpleRequestString).subscribe(
          ({ StatusCode, Message, Data }) =>
            Data !== false
              ? this.handleVerifySuccess(Data)
              : this.handleVerifyError(StatusCode),
          (error) => {
            this.alert = {
              alertMessage: 'Unexpected error. Please try again later.',
              alertType: 'alert alert-danger',
              alertCenter: false,
              alerTitle: '',
              duration: 3000,
            };
            localStorage.setItem('AlertObject', JSON.stringify(this.alert));
            this.alertService.updateAlertState(this.alert);
            this.clearFields();
          }
        );

      } else {
        this.simpleRequestString.value = userEmail;
        this.simpleRequestString.secondValue = codigoCompleto;
        this.loginService.verifyCode(this.simpleRequestString).subscribe(
          ({ StatusCode, Message, Data }) =>
            Data !== false
              ? this.handleVerifySuccess(Data)
              : this.handleVerifyError(StatusCode),
          (error) => {
            this.alert = {
              alertMessage: 'Unexpected error. Please try again later.',
              alertType: 'alert alert-danger',
              alertCenter: false,
              alerTitle: '',
              duration: 3000,
            };
            localStorage.setItem('AlertObject', JSON.stringify(this.alert));
            this.alertService.updateAlertState(this.alert);
            this.clearFields();
          }
        );
      }
    } else {
      this.alert = {
        alertMessage: 'The code entered is not valid.',
        alertType: 'alert alert-danger',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };
      this.alertService.updateAlertState(this.alert);
      this.clearFields();
    }
  }

  handleVerifyError(StatusCode: number) {
    this.alert = {
      alertMessage: 'The code entered is not valid.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    this.alertService.updateAlertState(this.alert);
    this.clearFields();
  }

  handleVerifySuccess(data: boolean) {
    localStorage.setItem('Code', data.toString());
    localStorage.removeItem('UserEmail');
    localStorage.removeItem('verifyCodeBy');
    this.router.navigate(['/home']);
  }

  clearFields(): void {
    this.otpInputs = new Array(6).fill('');
    this.currentInput = 0;
    this.fieldsCompleted = false;
  }

  reiniciarContador() {
    this.resendRequestString.value = this.email;
    if (this.selectedMethod === 'sms' && this.contadorResendClicks < 3) {
      
      this.loginService
        .resendVerificationCode(this.resendRequestString)
        .subscribe(
          ({ StatusCode, Message, Data }) =>
            Data !== null
              ? this.handleResendVerificationCode(Data)
              : this.handleError(StatusCode),
          (error) => {
            this.alert = {
              alertMessage: 'Unexpected error. Please try again later.',
              alertType: 'alert alert-danger',
              alertCenter: false,
              alerTitle: '',
              duration: 3000,
            };
            localStorage.setItem('AlertObject', JSON.stringify(this.alert));
            this.alertService.updateAlertState(this.alert);
            this.clearFields();
          }
        );

      this.contadorResendClicks++;
    }
    else{
      this.loginService
        .sendVerificationEmail(this.resendRequestString)
        .subscribe(
          ({ StatusCode, Message, Data }) =>
            Data !== null
              ? this.handleResendVerificationCode(Data)
              : this.handleError(StatusCode),
          (error) => {
            this.alert = {
              alertMessage: 'Unexpected error. Please try again later.',
              alertType: 'alert alert-danger',
              alertCenter: false,
              alerTitle: '',
              duration: 3000,
            };
            localStorage.setItem('AlertObject', JSON.stringify(this.alert));
            this.alertService.updateAlertState(this.alert);
            this.clearFields();
          }
        );

      this.contadorResendClicks++;
    }
  }

  handleResendVerificationCode(data: boolean) {
    this.clearFields();
    if (data) this.iniciarContador();
  }

  enviarCorreoConCodigo() {
    if (this.email != null) {
      this.resendRequestString.value = this.email;
      this.loginService
        .sendVerificationEmail(this.resendRequestString)
        .subscribe(
          ({ StatusCode, Message, Data }) =>
            Data !== null
              ? this.handleSendVerificationEmail(Data)
              : this.handleError(StatusCode),
          (error) => {
            this.alert = {
              alertMessage: 'Unexpected error. Please try again later.',
              alertType: 'alert alert-danger',
              alertCenter: false,
              alerTitle: '',
              duration: 3000,
            };
            localStorage.setItem('AlertObject', JSON.stringify(this.alert));
            this.alertService.updateAlertState(this.alert);
            this.clearFields();
          }
        );

      this.contadorResendClicks++;
    }
  }

  handleSendVerificationEmail(data: boolean) {
    if (data) this.iniciarContador();
  }

  goToLogin() {
    localStorage.clear();
    localStorage.removeItem('Permissions');
    localStorage.removeItem('JWT');
    localStorage.removeItem('Code');
    localStorage.removeItem('AlertObject');
    localStorage.removeItem('UserEmail');
    this.router.navigate(['/login']);
  }

  changeVerificationMethod() {
    localStorage.removeItem('verifyCodeBy');
    this.router.navigate(['/security-verification-options']);
  }

 

 


  onPaste(event: ClipboardEvent) {
    
    event.preventDefault();
    const pasteData = event.clipboardData?.getData('text').trim() || '';

    if (/^\d{6}$/.test(pasteData)) {
      this.otpInputs = pasteData.split('');
      //this.updateFullCode();
      this.focusNextInput(5); // Focus last input
      this.checkFieldsCompleted();
    }
  }

}
